package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiPost
import com.arena_web.data.http.apiPut
import io.ktor.client.*

class BookingApi(private val client: HttpClient) {

    suspend fun createBooking(request: CreateBookingRequest): ApiResponse<BookingDto> {
        return client.apiPost("v1/bookings", request)
    }

    suspend fun editBooking(bookingId: String, request: EditBookingRequest): ApiResponse<BookingDto> {
        return client.apiPut("v1/bookings/$bookingId/edit", request)
    }

    suspend fun cancelBooking(bookingId: String): ApiResponse<BookingDto> {
        return client.apiPut("v1/bookings/$bookingId/cancel", Unit)
    }
}
